<template>
    <div class="qrcodeBox">
        <div id="qrcode" ref="qrcode"></div>
    </div>
</template>

<script>
    import QRCode from "qrcodejs2";
    export default {
        name: "Qrcode",
        props:{
            qrcode:{
                type:String,
                default:""
            },
            width:{
                type:Number,
                default: 150
            },
            height:{
                type:Number,
                default:150
            }
        },
        data(){
            return {
                qr:null,
            }
        },
        mounted() {
           this.crateQrcode()
        },
        methods:{
            // 生成二维码
            crateQrcode () {
                this.qr = new QRCode('qrcode', {
                    width: this.width,
                    height: this.height, // 高度
                    text: this.qrcode // 二维码内容
                })
            },
            // 关闭弹框,清除已经生成的二维码
            closeCode () {
                this.$refs.qrcode.innerHTML = ''
            }
        }

    }
</script>

<style lang="scss" scoped>
    .qrcodeBox{
        width: 100%;
     
        display: flex;
        justify-content: center;
        align-content: center;
    }
</style>